import { useEffect, useRef, useState } from 'react';
import { AttachFile } from '@material-ui/icons';
import { AttachmentUpload } from '../../../types/commonTypes';
import { useNotification } from '../../../contexts/NotificationContext';
import { formatBytes } from '../../../lib/formatters';
import { Tooltip } from '../../../components/Tooltip';
import { IconButton } from '../../../components/IconButton';

interface Props {
  attachments: AttachmentUpload[];
  disabled?: boolean;
  setAttachments(attachment: AttachmentUpload[]): void;
  limitFileCount?: number;
  limitFileSize?: number; //in bytes
  limitBuffer?: number; //in bytes
}

export const AttachFileButton = ({
  attachments,
  disabled,
  setAttachments,
  limitFileCount,
  limitFileSize,
  limitBuffer,
}: Props) => {
  const [totalFileSize, setTotalFileSize] = useState(0);
  const fileSizeLimit = limitFileSize ? limitFileSize : 10000000; //in bytes
  const buffer = limitBuffer ? limitBuffer : 20000; //in bytes

  const uploadRef = useRef<HTMLInputElement>(null);
  const notification = useNotification();

  const handleDisable = (): boolean => {
    if (
      (limitFileCount && attachments.length === limitFileCount) ||
      fileSizeLimit - totalFileSize < buffer
    )
      return true;
    else return false;
  };

  useEffect(() => {
    let total = 0;
    attachments.forEach((attachment: any) => {
      total += attachment.size;
    });
    setTotalFileSize(total);
  }, [attachments]);

  const readUpload = (event: any) => {
    if (event.target.files[0] && event.target.files[0].size) {
      if (totalFileSize + event.target.files[0].size > fileSizeLimit) {
        attachments.length > 0
          ? notification.addNotification({
              dismissible: true,
              message: `Total file size must be less than ${formatBytes(
                fileSizeLimit
              )}`,
              type: 'error',
            })
          : notification.addNotification({
              dismissible: true,
              message: `File size must be less than ${formatBytes(
                fileSizeLimit
              )}`,
              type: 'error',
            });
      } else {
        const filename = event.target.files[0].name;
        const reader = new FileReader();
        const size = event.target.files[0].size;
        reader.onload = () =>
          attachments.length
            ? setAttachments([
                ...attachments,
                {
                  base64: reader.result,
                  filename: filename,
                  size: size,
                },
              ])
            : setAttachments([
                {
                  base64: reader.result,
                  filename: filename,
                  size: size,
                },
              ]);
        reader.readAsDataURL(event.target.files[0]);
      }
    }
  };

  return (
    <>
      <Tooltip title="Attach files" showArrow placement="top">
        <IconButton
          className="mx-3"
          onClick={() => {
            if (uploadRef.current) uploadRef.current.click();
          }}
          disabled={handleDisable() || disabled}
        >
          <AttachFile />
        </IconButton>
      </Tooltip>
      <input
        id="uploadFile_input"
        type="file"
        className="hidden w-0"
        ref={uploadRef}
        onChange={readUpload}
      />
    </>
  );
};
